import { Lock } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface Props {
  show: boolean
  onClose: () => void
}

export function TrialExpiredModal({ show, onClose }: Props) {
  const navigate = useNavigate()
  if (!show) return null

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 p-4 sm:items-center">
      <div className="card w-full max-w-sm p-6 space-y-5">
        <div className="flex flex-col items-center text-center gap-3">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
            <Lock className="h-6 w-6 text-red-600" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-900">Your trial has expired</h2>
            <p className="mt-1 text-sm text-gray-500">
              To continue making changes in Palstro, subscribe to a plan.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <button
            className="btn-primary"
            onClick={() => { navigate('/subscription'); onClose() }}
          >
            View Plans
          </button>
          <button className="btn-secondary" onClick={onClose}>
            Continue Reading Only
          </button>
        </div>
      </div>
    </div>
  )
}
